import React, { FC } from 'react'
import styled from 'styled-components'

export type Props = {
  width?: number
  isActive: boolean
  translation?: number
}

export const Slide: FC<Props> = ({ isActive = false, children, ...restProps }) => {
  return (
    <StyledSlide isActive={isActive} {...restProps}>
      {children}
    </StyledSlide>
  )
}

const StyledSlide = styled.div<Props>`
  position: relative;
  flex: 0 0 100%;
  opacity: ${({ isActive }) => (isActive ? 1 : 0)};
  transition: opacity 0.3s;
`
